var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-body" },
      [
        _c("b-table", {
          attrs: {
            "empty-text": _vm.empty,
            "show-empty": "",
            items: _vm.approvals,
            fields: _vm.fields,
            busy: _vm.loading,
            "no-border-collapse": "",
            responsive: ""
          },
          scopedSlots: _vm._u([
            {
              key: "head(actions)",
              fn: function() {
                return [
                  _vm._v(" Acciones "),
                  _c(
                    "CheckPermission",
                    { attrs: { permission: "ED265" } },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip",
                              value: "Descargar listado",
                              expression: "'Descargar listado'"
                            }
                          ],
                          staticClass: "badge-glow mb-2 ml-3",
                          attrs: {
                            variant: "warning",
                            size: "sm",
                            "data-cy": "download"
                          },
                          on: {
                            click: function($event) {
                              return _vm.descargarListado()
                            }
                          }
                        },
                        [
                          _c("feather-icon", {
                            attrs: { icon: "DownloadIcon" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            },
            {
              key: "cell(desatendida)",
              fn: function(ref) {
                var item = ref.item
                return [
                  item.desatendida === 1
                    ? _c("span", { staticClass: "badge badge-warning" }, [
                        _vm._v(" SI ")
                      ])
                    : _vm._e(),
                  item.desatendida !== 1
                    ? _c("span", { staticClass: "badge badge-secondary" }, [
                        _vm._v(" NO ")
                      ])
                    : _vm._e()
                ]
              }
            },
            {
              key: "cell(in_progress)",
              fn: function(ref) {
                var item = ref.item
                return [
                  item.in_progress === 0
                    ? _c("span", { staticClass: "badge badge-success" }, [
                        _vm._v(" " + _vm._s(item.in_progress) + " ")
                      ])
                    : _vm._e(),
                  item.in_progress > 0
                    ? _c("span", { staticClass: "badge badge-warning" }, [
                        _vm._v(" " + _vm._s(item.in_progress) + " ")
                      ])
                    : _vm._e()
                ]
              }
            },
            {
              key: "cell(type)",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-start align-items-center"
                    },
                    [
                      item.executionType !== "P"
                        ? _c("vs-icon", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Normal",
                                expression: "'Normal'"
                              }
                            ],
                            staticClass: "cursor-default mr-1",
                            attrs: { icon: "arrow_forward", size: "small" }
                          })
                        : _vm._e(),
                      item.executionType === "P"
                        ? _c("vs-icon", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Por monto",
                                expression: "'Por monto'"
                              }
                            ],
                            staticClass: "cursor-pointer",
                            attrs: { icon: "attach_money", size: "small" }
                          })
                        : _vm._e(),
                      _c("div", [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.getType(item.type),
                                expression: "getType(item.type)"
                              }
                            ],
                            staticClass: "cursor-default mr-2"
                          },
                          [_vm._v(" " + _vm._s(_vm.getType(item.type)) + " ")]
                        ),
                        _vm.findPurchaseType(item.objectCategoryType)
                          ? _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.findPurchaseType(
                                      item.objectCategoryType
                                    ),
                                    expression:
                                      "findPurchaseType(item.objectCategoryType)"
                                  }
                                ],
                                staticClass: "badge badge-warning"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("truncate")(
                                        _vm.findPurchaseType(
                                          item.objectCategoryType
                                        ),
                                        20
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ]
              }
            },
            {
              key: "cell(name)",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "col-11" }, [
                      _c("h4", { staticClass: "text-primary mb-1" }, [
                        _vm._v(_vm._s(item.name))
                      ]),
                      item.app === "ED"
                        ? _c(
                            "small",
                            { staticClass: "mr-3 badge badge-primary" },
                            [_vm._v(" " + _vm._s(item.app) + " ")]
                          )
                        : _vm._e(),
                      item.app === "FEB"
                        ? _c(
                            "small",
                            { staticClass: "mr-3 badge badge-warning" },
                            [_vm._v(" " + _vm._s(item.app) + " ")]
                          )
                        : _vm._e(),
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover.bottom",
                              value: "Descripción",
                              expression: "'Descripción'",
                              modifiers: { hover: true, bottom: true }
                            }
                          ],
                          staticClass: "text-secondary"
                        },
                        [
                          _c("b", [
                            _vm._v(_vm._s(item.description.toLowerCase()))
                          ])
                        ]
                      )
                    ])
                  ]),
                  _c("hr", { staticClass: "col-9 mb-2 mt-0" }),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 d-flex align-items-start" },
                      [
                        _c(
                          "vs-chip",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value:
                                  "Cantidad de documentos en curso. Puedes hacer click para verlas!",
                                expression:
                                  "'Cantidad de documentos en curso. Puedes hacer click para verlas!'"
                              }
                            ],
                            staticClass: "mr-3 cursor-pointer",
                            nativeOn: {
                              click: function($event) {
                                return _vm.seeDocuments(item)
                              }
                            }
                          },
                          [
                            _c("vs-avatar", {
                              attrs: {
                                text: item.in_progress.toString(),
                                badgeColor: "warning",
                                color: item.in_progress > 0 ? "#28c76f" : "gray"
                              }
                            }),
                            _vm._v(" Aprobaciones ")
                          ],
                          1
                        ),
                        item.unitName
                          ? _c(
                              "vs-chip",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Unidad",
                                    expression: "'Unidad'"
                                  }
                                ],
                                staticClass: "mr-3"
                              },
                              [
                                _c("vs-avatar", {
                                  attrs: { icon: "apartment" }
                                }),
                                _vm._v(" " + _vm._s(item.unitName) + " ")
                              ],
                              1
                            )
                          : _vm._e(),
                        item.date
                          ? _c(
                              "vs-chip",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Fecha de creación",
                                    expression: "'Fecha de creación'"
                                  }
                                ],
                                staticClass: "mr-3"
                              },
                              [
                                _c("vs-avatar", {
                                  attrs: {
                                    color: "#ff9f43",
                                    icon: "date_range"
                                  }
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._f("dateFormat")(item.date)) +
                                    " "
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "vs-chip",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.findPurchaseType(
                                  item.objectCategoryType
                                ),
                                expression:
                                  "findPurchaseType(item.objectCategoryType)"
                              }
                            ],
                            staticClass: "mr-3"
                          },
                          [
                            _c("vs-avatar", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.left",
                                  value:
                                    "Tipo de ejecución:                " +
                                    (item.executionType === "P"
                                      ? "Por monto"
                                      : "Normal"),
                                  expression:
                                    "`Tipo de ejecución:\\\n                ${item.executionType === 'P' ? 'Por monto':'Normal'}`",
                                  modifiers: { hover: true, left: true }
                                }
                              ],
                              attrs: {
                                color: "#ff9f43",
                                icon:
                                  item.executionType === "P"
                                    ? "attach_money"
                                    : "arrow_forward"
                              }
                            }),
                            _c("span", { staticClass: "cursor-default mr-2" }, [
                              _vm._v(_vm._s(_vm.getType(item.type)))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              }
            },
            {
              key: "cell(actions)",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c(
                    "div",
                    { staticClass: "col-1 p-0" },
                    [
                      _c("TableActions", {
                        attrs: {
                          load: _vm.load,
                          fetchTemplates: _vm.fetchTemplates,
                          item: item
                        }
                      })
                    ],
                    1
                  )
                ]
              }
            },
            {
              key: "table-busy",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "text-center text-danger my-2" },
                    [_c("b-spinner", { staticClass: "align-middle" })],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        }),
        _vm.templatePaginationData &&
        _vm.templatePaginationData.totalPaginas > 1
          ? _c("div", { staticClass: "row margin" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("FbPaginacion", {
                    attrs: {
                      total: _vm.templatePaginationData.totalPaginas,
                      max: 10
                    },
                    model: {
                      value: _vm.page,
                      callback: function($$v) {
                        _vm.page = $$v
                      },
                      expression: "page"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }